import React, { ReactNode, CSSProperties } from 'react';
import { makeStyles } from '~/UIKit/Style';
import { PRIMARY_BLUE, FITOGRAM_BLUE_FADED_8 } from '~/Constants/Colors.constants';

export interface CustomerTagProps {
  children: ReactNode;
  customCss?: CSSProperties;
}
const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: FITOGRAM_BLUE_FADED_8,
    border: `1px solid ${PRIMARY_BLUE}`,
    borderRadius: 12,
    padding: '3.5px 12px',
    fontSize: 12,
    lineHeight: '16px',
    letterSpacing: 0.5,
    color: PRIMARY_BLUE,
    display: 'inline-block',
    marginTop: 2,
    marginBottom: 2,
    marginRight: 8,
    whiteSpace: 'nowrap',
    '&:last-of-type': {
      marginRight: 0,
    },
  },
}));
export const Tag = ({ children, customCss }: CustomerTagProps) => {
  const { classes, cx } = useStyles();
  return <span className={cx(classes.root, customCss)}>{children}</span>;
};
